export const ExportIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="vuesax/outline/export">
      <g id="export">
        <path
          id="Vector"
          d="M8.66679 7.83414C8.54012 7.83414 8.41346 7.78747 8.31346 7.68747C8.12012 7.49414 8.12012 7.17414 8.31346 6.98081L13.7801 1.51414C13.9735 1.32081 14.2935 1.32081 14.4868 1.51414C14.6801 1.70747 14.6801 2.02747 14.4868 2.22081L9.02012 7.68747C8.92012 7.78747 8.79346 7.83414 8.66679 7.83414Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M14.6668 5.03398C14.3935 5.03398 14.1668 4.80732 14.1668 4.53398V1.83398H11.4668C11.1935 1.83398 10.9668 1.60732 10.9668 1.33398C10.9668 1.06065 11.1935 0.833984 11.4668 0.833984H14.6668C14.9401 0.833984 15.1668 1.06065 15.1668 1.33398V4.53398C15.1668 4.80732 14.9401 5.03398 14.6668 5.03398Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          d="M10.0002 15.1673H6.00016C2.38016 15.1673 0.833496 13.6207 0.833496 10.0007V6.00065C0.833496 2.38065 2.38016 0.833984 6.00016 0.833984H7.3335C7.60683 0.833984 7.8335 1.06065 7.8335 1.33398C7.8335 1.60732 7.60683 1.83398 7.3335 1.83398H6.00016C2.92683 1.83398 1.8335 2.92732 1.8335 6.00065V10.0007C1.8335 13.074 2.92683 14.1673 6.00016 14.1673H10.0002C13.0735 14.1673 14.1668 13.074 14.1668 10.0007V8.66732C14.1668 8.39398 14.3935 8.16732 14.6668 8.16732C14.9402 8.16732 15.1668 8.39398 15.1668 8.66732V10.0007C15.1668 13.6207 13.6202 15.1673 10.0002 15.1673Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
